import _extends from 'babel-runtime/helpers/extends';
import shuffle from 'lodash/shuffle';
import { sequenceModel } from '../sequence-model';
export var LOAD_SEQUENCE = 'LOAD_SEQUENCE';

var SET_SEQUENCE = 'SET_SEQUENCE';

var initialSequenceState = {
  loading: false,
  sequence: null
};

export var sequenceReducer = function sequenceReducer() {
  var sequenceState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialSequenceState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  switch (action && action.type) {
    // here is for actions that only want saga side-effects
    case LOAD_SEQUENCE:
      return _extends({}, sequenceState, {
        loading: true,
        sequence: null
      });

    case SET_SEQUENCE:
      var newSequence = action.payload.sequence;
      // test sequences get their activities shuffled
      if (sequenceModel.getIsTestSequence(newSequence)) {
        newSequence.activities = shuffle(newSequence.activities);
      }
      return _extends({}, sequenceState, {
        loading: false,
        sequence: newSequence
      });

    default:
      return sequenceState;
  }
};

export var sequenceActions = {
  loadSequence: function loadSequence(queryVars) {
    return { type: LOAD_SEQUENCE, payload: { queryVars: queryVars } };
  },
  setSequence: function setSequence(sequence) {
    return { type: SET_SEQUENCE, payload: { sequence: sequence } };
  }
};

export var sequenceSelectors = {
  getIsSequenceLoading: function getIsSequenceLoading(state) {
    return state.sequence.loading;
  },
  getSequence: function getSequence(state) {
    return state.sequence.sequence;
  },
  isTestSequence: function isTestSequence(state) {
    return sequenceModel.getIsTestSequence(state.sequence.sequence);
  }
};